import { Pipe, PipeTransform } from "@angular/core";
import { Message } from "@handshake/core-types";

@Pipe({
  name: "diffMinute",
})
export class DiffMinutePipe implements PipeTransform {
  transform(currentMessage: Message, messages: Message[], index: number, minute: number = 10): boolean {
    return this.shouldShowTime(currentMessage, messages, index, minute);
  }

  shouldShowTime(currentMessage: Message, messages: Message[], index: number, minute: number): boolean {
    if (index === 0) return true;

    const previousMessage = messages[index - 1];
    const currentTime = new Date(currentMessage.createdAt).getTime();
    const previousTime = new Date(previousMessage.createdAt).getTime();

    return previousMessage.senderRole !== currentMessage.senderRole || currentTime - previousTime > minute * 60000;
  }
}
